const QalaSgtmUrl = QalaSgtmSettings?.sgtm_container_url;
const QalaSgtmContainerPath = QalaSgtmSettings?.sgtm_container_path ?? 'gtm';
const QalaSgtmId = QalaSgtmSettings?.sgtm_container_id;
const enableCookieKeeper = QalaSgtmSettings?.enable_cookie_keeper ?? false;

if ( QalaSgtmId && QalaSgtmContainerPath && QalaSgtmUrl ) {
	// Check if we are dealing with Safari 16.4+.
	const isSafari164Plus = () => {
		const match = /Version\/([0-9._]+).*Safari/.exec( navigator.userAgent );
		return match ? parseFloat( match[ 1 ] ) >= 16.4 : false;
	};

	// Small helpers to get and set cookies.
	const getCookie = name => {
		const value = document.cookie.split( '; ' ).find( row => row.startsWith( name + '=' ) );
		return value ? value.split( '=' )[ 1 ] : undefined;
	};

	const setCookie = ( name, value, days = 180 ) => {
		const expires = new Date( Date.now() + ( days * 864e5 ) ).toUTCString();
		document.cookie = `${ name }=${ value }; expires=${ expires }; path=/; SameSite=Lax`;
	};

	// Either gets the cookie for the browser ID, or generates a new one if none exists.
	// Uses Crypto if available.
	const getOrCreateBrowserId = () => {
		let id = getCookie( '_sbp' );
		if ( ! id ) {
			if ( typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ) {
				id = crypto.randomUUID();
			} else {
				id = Math.random().toString( 36 ).substring( 2 ) + Date.now();
			}
			setCookie( '_sbp', id );
		}
		return id;
	};

	const shouldGenerateId = enableCookieKeeper && isSafari164Plus();
	const browserId = shouldGenerateId ? getOrCreateBrowserId() : getCookie( '_sbp' );
	const useKeeper = enableCookieKeeper && isSafari164Plus() && !! browserId;
	// Modifies the container path if the cookie keeper is enabled and the current path doesn't start with 'kp'.
	const modifiedContainerPath = useKeeper && ! QalaSgtmContainerPath.startsWith( 'kp' )
		? QalaSgtmContainerPath.replace( /([a-z]{8})$/, 'kp$1' )
		: QalaSgtmContainerPath;
	// Adds the browser ID to the dataLayer if it exists.
	const biParam = browserId ? '&bi=' + encodeURIComponent( decodeURIComponent( browserId ) ) : '';
	// Create the source url for the GTM container.
	const src = `${ QalaSgtmUrl }/${ modifiedContainerPath }.js?id=${ QalaSgtmId }${ biParam }`;

	// Creates the datalayer object and pushes the initial event.
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push( { 'gtm.start': new Date().getTime(), event: 'gtm.js' } );

	// Finally, put it all together.
	const f = document.getElementsByTagName( 'script' )[ 0 ];
	const j = document.createElement( 'script' );
	j.async = true;
	j.src = src;
	f.parentNode.insertBefore( j, f );
}
